import { Avatar, Badge, Box } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import { tokens } from '../lib/tokens'

interface DoctorAvatarProps {
  size?: number
  iconSize?: number
  dotSize?: number
}

export function DoctorAvatar({ size = 40, iconSize = 20, dotSize = 10 }: DoctorAvatarProps) {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={<Box component="span" sx={{ width: dotSize, height: dotSize, bgcolor: tokens.emerald, border: '2px solid #fff', borderRadius: '50%' }} />}
      sx={{ flexShrink: 0 }}
    >
      <Avatar
        sx={{
          width: size,
          height: size,
          bgcolor: tokens.surfaceContainer,
          color: tokens.primary,
          border: '2px solid',
          borderColor: `${tokens.primaryContainer}33`,
        }}
      >
        <PersonIcon sx={{ fontSize: iconSize }} />
      </Avatar>
    </Badge>
  )
}
